module.exports = __webpack_public_path__ + "static/media/mail.2e7fab18.svg";